<template>
  <b-row>
    <b-col cols="0" md="1" lg="2" />

    <b-col>
      <ai-chat />
    </b-col>

    <b-col cols="0" md="1" lg="2" />
  </b-row>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";

import AiChat from "@/components/AIChat/";

export default {
  name: "JlAi",
  components: { BRow, BCol, AiChat },
};
</script>
